import * as React from 'react';
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import { TableHead, TextField, Chip, Checkbox } from '@mui/material';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import { useGetUsersQuery } from '../../features/users/usersApiSlice';
import { useLocation, Navigate, Outlet } from "react-router-dom";
import nameStringFn from "../../data/nameStringFn";
import {HeadingWrap, Span, CommonButton } from '../../Styles/CommonStyles';
import {TableContStyle, TableHeadStyle } from '../../Styles/TableStyles';
import { useGetdesignationsQuery } from '../../features/designations/designationApiSlice';
import DetailsIcon from '@mui/icons-material/Details';
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { useGetofficesQuery } from '../../features/offices/officesApiSlice';
import useAuth from '../../features/hooks/useAuth';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import ExcelDownload from '../../data/exceldownload';
import { useGetStoreOfficesQuery } from '../../features/storeoffices/storeofficesApiSlice';
import { useGetComplMastersQuery } from '../../features/complmaster/complmasterApiSlice';
import { useAddNewSupportUserMutation, useGetSupportUsersQuery } from '../../features/supportusers/supportusersApiSlice';
import { useGetAssetMastersQuery } from '../../features/assetmasterApiSlice/assetmasterApiSlice';
import SupportDetailsModal from './SupportDetailsModal';



const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const Button2Div =styled.div`
  display: flex;
  justify-content: end;
`

function TablePaginationActions(props) {
  const start = performance.now();

  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );

}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const tableFontSize = 18;

// The user Roles Array function creates an array of all roles so that they can be displayed as chips in the table.
const userRolesArray = (userObject) => {
  if (!userObject?.roles) return [];
  
  const mainRoleArray = userObject?.roles?.main || [];
  let officeRoleArray = [];
  
  for(let key in userObject?.roles){
    if(key !== "main" && userObject?.roles[key]){
      for(let val of userObject?.roles[key]){
        if (val) officeRoleArray.push(`${val} (${key})`)
      }
    }
  }
  
  return mainRoleArray.concat(officeRoleArray);
}


//The findSubordinateOffices function gives an array of objects of all offices which are subordinate to officeName.
const findSubordinateOffices = (offices, officeName, result = []) => {
  const subOffices = offices? offices?.filter(office => office?.superioroffice === officeName):[];
  for (const subOffice of subOffices) {
    result.push(subOffice);
    findSubordinateOffices(offices, subOffice?.name, result);
  }
  return result;
}

//The filterFunctionUser gives the array of filtered array of users as per roles available.
const filterFunctionUser =  (userArray, Auth, presentOffice, officeArray ) =>{
  const start = performance.now();
  let tempArray = {...userArray};

  console.log(userArray)
  const rolesArray = Auth.roles[presentOffice];
  console.log(rolesArray)
  if(Auth.roles["main"].includes("Admin") || rolesArray.some(item => ["level1approver", "level2approver"].includes(item)) ){
    console.log("Admin")
    const end = performance.now();
    console.log(`someFunction took ${end - start} ms`);
    return userArray;
  }
  if(rolesArray.includes("Bo") && !rolesArray.includes("UnitHead")){
    console.log("BO")
    tempArray = tempArray.filter(x => Object.values(x.office).flat(3).includes(presentOffice))
    console.log(tempArray)
    const end = performance.now();
    console.log(`someFunction took ${end - start} ms`);
    return tempArray
  }
  if(rolesArray.includes("UnitHead")){
    console.log("unithead")
    const subordinateOffices = findSubordinateOffices(officeArray, presentOffice).map(x=> x.name)
    tempArray = tempArray.filter(x => Object.values(x.office).flat(3).some(item => subordinateOffices.concat(presentOffice).includes(item)));
    console.log(tempArray)
    const end = performance.now();
    console.log(`someFunction took ${end - start} ms`);
    return tempArray
  }


}

//This is a function which returns true if
// 1. If B is an Array there should be atleast one common element between A & B.
// 2. If B is String the Array A should have one of the element as that string.

const hasCommonElement = (A, B)=> {
  if (Array.isArray(B)) {
    // Check if there is at least one common element between arrays A and B
    return A.some(element => B.includes(element));
  } else if (typeof B === 'string') {
    // Check if array A contains the string B
    return A.includes(B);
  } else {
    // Handle other cases (e.g., B is neither an array nor a string)
    return false;
  }
}

export default function CustomPaginationActionsTable() {

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [supportdetailmodalopen, setSupportDetailmodalopen] = useState(false);
  const [supportdetailModaldata, setSupportDetailModaldata] = useState({});
  const [downloadData, setDownloadData] = useState({});


  const [searchData, setSearchData] = useState({
    name:"",
    email:"",
    store:[],
    mobileNo:"",
    assetCategories:[],
    complaintCategories:[]
  }); 

  const {supportuser} = useGetSupportUsersQuery("supportuser", {
    selectFromResult: ({ data }) => ({
      supportuser: data?.entities
    }),
  });

  const {assetmaster} = useGetAssetMastersQuery("assetmaster", {
    selectFromResult: ({ data }) => ({
      assetmaster: data?.entities
    }),
  });


  const {users} =  useGetUsersQuery("UserList", {
    selectFromResult: ({ data }) => ({
      users: data?.entities
    }),
  })

  const {designations} = useGetdesignationsQuery("DesigList", {
    selectFromResult: ({ data }) => ({
      designations: data?.entities
    }),
  })

  const {offices} = useGetofficesQuery("OffList", {
    selectFromResult: ({ data }) => ({
      offices: data?.entities
    }),
  })
  const {storeoffices}= useGetStoreOfficesQuery("storeoffices", {
    selectFromResult: ({ data }) => ({
      storeoffices: data?.entities
    }),
  })
  const {complmaster} = useGetComplMastersQuery("complList", {
    selectFromResult: ({ data }) => ({
      complmaster: data?.entities
    }),
  })
  console.log(offices? findSubordinateOffices(Object.values(offices), "C.E (DSO)"):[])

  const [tabledata, setTabledata]= useState([]);

  // console.log(useSelector(state => state.office.off))


  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - tabledata.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleDetailsClick = (e, row)  => {
    setSupportDetailModaldata(row);
    setSupportDetailmodalopen(true)
  };
  const handleSupportDetailModalClose = () => {
    setSupportDetailmodalopen(false);
  };

 const handleSearchChange = (event, newValue, name) =>{
    let tempData = Object.values(supportuser);
    let tempSearchData = structuredClone(searchData);
    if(event?.target?.name){
      tempSearchData[event.target.name] = event.target.value;
      setSearchData(tempSearchData);
     }else{
      tempSearchData[name] = newValue
      setSearchData(tempSearchData);
     }
     for(let key in tempSearchData){
      console.log(key)
      if(typeof tempSearchData[key] === "string" && tempSearchData[key].length){
        console.log("Entry1")
          if(key === "name"){
            tempData = tempData.filter(x=> nameStringFn(x).toLowerCase().includes(tempSearchData[key].toLowerCase()));
          }else{
            tempData = tempData.filter(x=> x[key].toLowerCase().includes(tempSearchData[key].toLowerCase()))
          }
      }
      if(typeof tempSearchData[key] === "object" && tempSearchData[key].length ){
        console.log("Entry2")
        if(typeof tempSearchData[key][0] === "string" && ["store"].includes(name)){
          console.log("Entry3")
          tempData = tempData.filter(x=> tempSearchData[key].includes(x.store))
        }
        if(typeof tempSearchData[key][0] === "string" && ["roles","assetCategories","complaintCategories"].includes(name) ){
          console.log("Entry4")
          tempData = tempData.filter(x=> hasCommonElement(tempSearchData[key], x[key]))
        }
      }
    }
    setTabledata(tempData.sort((a, b) => {
      if (a?.name?.firstName < b?.name?.firstName) return -1;
      if (a?.name?.firstName > b?.name?.firstName) return 1;
      return 0;
    }));
  }
useEffect(()=>{
  if(supportuser){
    const supportUserArray = structuredClone(Object.values(supportuser));
    //Sorting based on Designation Level.
    setTabledata(supportUserArray.sort((a, b) => {
      if (a?.name?.firstName < b?.name?.firstName) return -1;
      if (a?.name?.firstName > b?.name?.firstName) return 1;
      return 0;
    }));    
  }
},[supportuser])


//Setting the download data for excel download.
useEffect(()=>{
  let finalDownloadData = [];
  let finalSortedDownloadData = [];
  const keyOrderArray = ["email", "name", "mobileNo", "roles", "store", "assetCategories","complaintCategories","assignedComplaint", "available", "disabled"]
  let tempDownloadData = structuredClone(tabledata);
  for(let val of tempDownloadData ){
      let {_id, password, ...others} = val;
      others = {...others, "name":nameStringFn(val), "roles":val.roles.join(),"assetCategories":val.assetCategories.join(), "complaintCategories":val.complaintCategories.join(),"assignedComplaint": val.assignedComplaint.join() }
      finalDownloadData.push(others)
    }

    for(let value of finalDownloadData){
        let tempObject = {}
        for(let val of keyOrderArray){
            tempObject = {...tempObject, [val]:value[val]};
        }
        finalSortedDownloadData.push(tempObject);
    }
    setDownloadData(finalSortedDownloadData)

}, [tabledata])


console.log(tabledata)
  return (
    <>    
      <HeadingWrap>
        <Span>All Support Users</Span>
      </HeadingWrap>
      <Button2Div>
          <ExcelDownload data={downloadData} filename={"myUsers"} sheetName={"sheet1"}/>
      </Button2Div> 
      <div>
      <TableContainer component={Paper} sx={{ backgroundColor: TableContStyle.backgroundColor }}>
      <Table sx={{ minWidth: 500 }} aria-label="custom pagination table">
      <TableHead  style={{backgroundColor: TableHeadStyle.backgroundColor }}>
        <TableRow >
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"5%"}}} >Sl.No.</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"16%"}}} align="left">Name</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"16%"}}}align="left">Email</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"16%"}}} align="left">Role</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"16%"}}} align="left">Store</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"16%"}}} align="left">Asset Category</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"18%"}}} align="left">Compl Category</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"15%"}}} align="left">Details</TableCell>
        </TableRow>
        <TableRow  >
          <TableCell>
          </TableCell>

          <TableCell>
            <TextField sx={{background:"white"}}  name='name' onChange={handleSearchChange} label="Search Name" size="small"  variant="outlined" />
          </TableCell>

          <TableCell>
            <TextField sx={{background:"white"}}  name='email' onChange={handleSearchChange} label="Search Email" size="small"  variant="outlined" />
          </TableCell>

          <TableCell>
          <Autocomplete
              multiple
              id="checkboxes-tags-demo"
              onChange={(event, newValue) => handleSearchChange(event, newValue, "roles")}
              size="small"
              value={searchData.roles}
              options={["SupportAdmin", "Supervisor", "SupportStaff"]}
              disableCloseOnSelect
              getOptionLabel={(option) => option}
              renderOption={(props, option, { selected }) => (
                <li {...props} style={{ fontSize: '2 rem' }}>
                  <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 0, marginLeft:0 }}
                    checked={selected}
                  />
                  {option}
                </li>
              )}
              renderInput={(params) => (
                <TextField {...params} label="Search Roles"  sx={{background:"white", width:"100%"}} />
              )}
              />
          </TableCell>


          <TableCell>

          <Autocomplete
              multiple
              id="checkboxes-tags-demo"
              onChange={(event, newValue) => handleSearchChange(event, newValue, "store")}
              size="small"
              value={searchData.store}
              options={storeoffices? Object.values(storeoffices).map(x => x.storeoffice).sort():[]}
              disableCloseOnSelect
              getOptionLabel={(option) => option}
              renderOption={(props, option, { selected }) => (
                <li {...props} style={{ fontSize: '2 rem' }}>
                  <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 0, marginLeft:0 }}
                    checked={selected}
                  />
                  {option}
                </li>
              )}
              renderInput={(params) => (
                <TextField {...params} label="Search Designation"  sx={{background:"white", width:"100%"}} />
              )}
              />
          </TableCell>


          <TableCell>

          <Autocomplete
              multiple
              id="checkboxes-tags-demo"
              onChange={(event, newValue) => handleSearchChange(event, newValue, "assetCategories")}
              size="small"
              value={searchData.assetCategories}
              //We set the options for available offices sorted by level and duplicacy removed.
              options={assetmaster ? Object.values(assetmaster).map(x => x.Category).sort():[]}
              disableCloseOnSelect
              getOptionLabel={(option) => option}
              renderOption={(props, option, { selected }) => (
                <li {...props} style={{ fontSize: '2 rem' }}>
                  <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 0, marginLeft:0 }}
                    checked={selected}
                  />
                  {option}
                </li>
              )}
              renderInput={(params) => (
                <TextField {...params} label="Search Asset Categ"  sx={{background:"white", width:"100%"}} />
              )}
              />
          </TableCell>
          <TableCell>

          <Autocomplete
              multiple
              id="checkboxes-tags-demo"
              onChange={(event, newValue) => handleSearchChange(event, newValue, "complaintCategories")}
              size="small"
              value={searchData.complaintCategories}
              options={complmaster? Object.values(complmaster).map(x => x.Category).sort():[]}
              disableCloseOnSelect
              getOptionLabel={(option) => option}
              renderOption={(props, option, { selected }) => (
                <li {...props} style={{ fontSize: '2 rem' }}>
                  <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 0, marginLeft:0 }}
                    checked={selected}
                  />
                  {option}
                </li>
              )}
              renderInput={(params) => (
                <TextField {...params} label="Search Compl Categ"  sx={{background:"white", width:"100%"}} />
              )}
              />
          </TableCell>
          <TableCell>
          </TableCell>
        </TableRow>
      </TableHead>
        <TableBody>
          {(rowsPerPage > 0
            ? tabledata.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            : tabledata
          ).map((row,index) => (
            <TableRow key={index}>
              <TableCell component="th" scope="row" sx={{ fontSize: tableFontSize}}>
              {(page)*(rowsPerPage)+index+1}
              </TableCell>
              <TableCell  align="left" sx={{ fontSize: tableFontSize}}>
                {nameStringFn(row)}
              </TableCell>
              <TableCell  align="left" sx={{ fontSize: tableFontSize}}>
              {row?.email}
              </TableCell>
              <TableCell  align="left" sx={{ fontSize: tableFontSize}}>
              { row?.roles?.map((item, index)=><Chip sx={{margin:"2px"}} key={index} label = {item} />)}
              </TableCell>  
              <TableCell  align="left" sx={{ fontSize: tableFontSize}}>
              {row?.store}
              </TableCell> 
            
              <TableCell align="left" sx={{ fontSize: tableFontSize, maxWidth:"200px"}}>
              { row?.assetCategories?.map((item, index)=><Chip sx={{margin:"2px"}} key={index} label = {item} />)}
              </TableCell>
              <TableCell align="left" sx={{ fontSize: tableFontSize, maxWidth:"200px"}}>
              { row?.complaintCategories?.map((item, index)=><Chip sx={{margin:"2px"}} key={index} label = {item} />)}
              </TableCell> 
              <TableCell  align="left" sx={{ fontSize: tableFontSize}}>
                <DetailsIcon sx={{color:"green", fontSize:"40px", '&:hover':{"cursor":"pointer"}}} onClick={(e) => handleDetailsClick(e, row)} />
              </TableCell> 
            </TableRow>
          ))}

          {emptyRows > 0 && (
            <TableRow style={{ height: 53 * emptyRows }}>
              <TableCell colSpan={6} />
            </TableRow>
          )}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
              colSpan={3}
              count={tabledata? tabledata?.length:[]}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: {
                  'aria-label': 'rows per page',
                },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
    </div>
    {supportdetailmodalopen && <SupportDetailsModal
      supportdetailmodalopen = {supportdetailmodalopen}
      supportdetailModaldata = {supportdetailModaldata}      
      handleSupportDetailModalClose = {handleSupportDetailModalClose}    
    />}
    </>
  );

}